import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "../../redux/store";
import TabManager from "./TabManager";
import RouteToComponentMapper from "../../config/RouteToComponentMapper";

const Workspace: React.FC = () => {
  const { tabs, activeTabId } = useAppSelector((state) => state.workspace);

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <TabManager />

      <Box sx={{ flex: 1, overflow: "hidden", position: "relative" }}>
        {tabs.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography color="text.secondary">
              Select an item from the sidebar to open a tab.
            </Typography>
          </Box>
        ) : (
          tabs.map((tab) => {
            const Component = RouteToComponentMapper[tab.componentKey];

            if (!Component) {
              return (
                <Box key={tab.id} hidden={activeTabId !== tab.id}>
                  Component Not Found
                </Box>
              );
            }

            return (
              <Box
                key={tab.id}
                role="tabpanel"
                hidden={activeTabId !== tab.id}
                sx={{ height: "100%", overflowY: "auto" }}
              >
                {/* Only render the component if it is the active tab OR if it has been mounted before (keeps state alive) */}
                <Component />
              </Box>
            );
          })
        )}
      </Box>
    </Box>
  );
};

export default Workspace;
